import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

type ActionVariant = "primary" | "muted" | "danger" | "disabled";
type ActionRounded = "sm" | "md" | "lg" | "xl" | "full";
type ActionAppearance = "solid" | "outline";

export type ActionProps = {
    label?: string;
    href?: string;
    variant?: ActionVariant;
    appearance?: ActionAppearance;
    rounded?: ActionRounded;
    external?: boolean;
    disabled?: boolean;
    onClick?: (event: MouseEvent) => void;
}



export default /*#__PURE__*/_defineComponent({
  __name: 'Action',
  props: {
    label: { default: "" },
    href: null,
    variant: { default: "primary" },
    appearance: { default: "solid" },
    rounded: { default: "sm" },
    external: { type: Boolean, default: false },
    disabled: { type: Boolean },
    onClick: null
  },
  setup(__props: any, { emit }: { emit: ({
    click: [event: MouseEvent]
}), expose: any, slots: any, attrs: any }) {

const props = __props as { label: string, href?: string, variant: ActionVariant, appearance: ActionAppearance, rounded: ActionRounded, external: boolean, disabled?: boolean, onClick?: (event: MouseEvent) => void };





const actionClasses = computed(() => [
    "app-action",
    `app-action--${props.variant}`,
    `app-action--${props.appearance}`,
    `app-action--rounded-${props.rounded}`,
    props.disabled && "app-action--disabled"
]);


return { __sfc: true,props, emit, actionClasses }
}

})